import { render, staticRenderFns } from "./createDisciplinaryRecord.vue?vue&type=template&id=96aa59a6&scoped=true"
import script from "./createDisciplinaryRecord.vue?vue&type=script&lang=js"
export * from "./createDisciplinaryRecord.vue?vue&type=script&lang=js"
import style0 from "./createDisciplinaryRecord.vue?vue&type=style&index=0&id=96aa59a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96aa59a6",
  null
  
)

export default component.exports